// 这是简体中文语言对象

export default {
  index: '首页',
  allContent: '全部内容',
  more: '更多',
  search: '搜索',
  searchHistory: '搜索记录',
  hotSearchRanking: '热搜排行',
  login: '登录',
  register: '注册',
  myLikes: '我的喜欢',
  myCollections: '我的收藏',
  browsingHistory: '浏览记录',
  myWallet: '我的钱包',
  mySupport: '我的支持',
  selectLanguage: '选择语言',
  darkMode: '深色模式',
  settings: '设置',
  logout: '退出登录',
  afterLoginYouCan: '登录后你可以',
  collectFavoriteWorks: '收藏你喜欢的作品',
  joinDiscussions: '参与互动讨论',
  viewBrowsingHistory: '查看浏览记录',
  loginNow: '立即登录',
  firstTimeHere: '第一次来？',
  clickToRegister: '点我注册',
  externalLink: '外部链接',
  pleaseEnterEmail: '请输入邮箱地址',
  pleaseEnterPassword: '请输入密码',
  forgotPassword: '忘记密码',
  readAndAgree: '已阅读并同意',
  userAgreementWithBracket: '《用户协议》',
  privacyPolicyWithBracket: '《隐私政策》',
  and: '和',
  copyright: 'Slash99 ©️2025 保留所有权利',
  aboutUs: '关于我们',
  userAgreement: '用户协议',
  privacyPolicy: '隐私政策',
  passwordErrorRetry: '密码错误，请重试',
  passwordErrorRemaining: '密码错误，还剩{count}次机会',
  accountLockedHint: '账号临时锁定，30分钟后重试或通过邮箱找回密码',
  passwordFormatError: '密码格式不正确，请输入8-20位包含字母和数字的密码',
  pleaseAgreeAgreement: '请先同意用户协议',
  pleaseEnterValidEmail: '请输入有效的邮箱地址',
  loading: '加载中...',
  loginFailedCheckAccount: '登录失败，请检查邮箱和密码',
  loginFailedServerDataError: '登录失败：服务器返回数据异常',
  loginSuccess: '登录成功',
  userBanned: '用户已被封禁',
  emailNotVerified: '邮箱未验证，请先验证邮箱后再登录',
  tip: '提示',
  confirmClearSearchHistory: '确定要清除搜索记录吗？',
  operationSuccess: '操作成功',
  changePassword: '修改密码',
  setNewPasswordHint: '设置新密码以保护您的账户安全',
  passwordRulePlaceholder: '8-20位密码，含字母+数字',
  pleaseEnterPasswordAgain: '请再次输入密码',
  enterVerificationCode: '输入验证码',
  resendAfterSeconds: 's后重发',
  sendVerificationCode: '发送验证码',
  emailFormatError: '邮箱地址不正确',
  passwordRuleDetail: '密码需满足：8-20位，含字母+数字',
  passwordMismatch: '密码不一致',
  unableToGetEmail: '无法获取用户邮箱',
  sending: '发送中...',
  codeSentSuccess: '验证码已发送',
  sendCodeFailed: '发送验证码失败',
  sendCodeFailedRetry: '发送验证码失败，请稍后重试',
  verificationCodeLengthError: '验证码为4位',
  submitting: '修改中...',
  passwordResetSuccess: '密码重置成功，请使用新密码登录',
  passwordChangeFailed: '密码修改失败',
  passwordChangeFailedRetry: '修改密码失败，请稍后重试',
  featureUnderDevelopment: '功能开发中',
  nextStep: '下一步',
  seconds: '秒',
  codeSentToEmail: '验证码已发送到\n您的邮箱',
  verifying: '验证中...',
  verificationCodeError: '验证码错误',
  codeSentToYourEmail: '验证码已发送到您的邮箱',
  emailAlreadyRegistered: '该邮箱已被注册',
  pleaseSendVerificationCodeFirst: '请先点击发送验证码',
  registering: '注册中...',
  registerSuccess: '注册成功',
  registerFailedRetry: '注册失败，请稍后重试',
  notSetYet: '暂未设置',
  confirmLogout: '确认退出',
  confirmLogoutMessage: '确定要退出登录吗？',
  cancel: '取消',
  accountSettings: '账户设置',
  editProfile: '修改个人信息',
  redeemCode: '兑换码',
  deleteAccount: '注销账户',
  legalInfo: '法律信息',
  noContent: '暂无内容',
  paymentIconLoadFailed: '支付图标加载失败',
  footerCopyright: '© 2025-2026 slash99.com. All rights reserved.',
  // 个人资料编辑
  changeAvatar: '更换头像',
  account: '账号',
  nickname: '昵称',
  pleaseEnterNickname: '请输入昵称',
  gender: '性别',
  save: '保存',
  selectGender: '选择性别',
  male: '男',
  female: '女',
  secret: '保密',
  uploading: '上传中...',
  uploadFailed: '上传失败',
  uploadFailedRetry: '上传失败，请稍后重试',
  chooseImageFailed: '选择图片失败',
  updateAvatarError: '修改头像异常',
  updateNicknameError: '修改昵称异常',
  avatarUploadingPleaseWait: '头像上传中，请稍候',
  nicknameFormatError: '昵称只支持汉字、英文、数字',
  nicknameLengthError: '昵称最长10个汉字或20个英文',
  noChangesToSave: '没有需要保存的更改',
  userIdNotExist: '用户ID不存在',
  saving: '保存中...',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  saveFailedRetry: '保存失败，请稍后重试',
  // 兑换码中心
  redeemCenter: '兑换中心',
  redeemSubtitle: '输入兑换码，获取专属权益',
  pleaseEnterRedeemCode: '请输入兑换码',
  paste: '粘贴',
  redeeming: '兑换中...',
  redeem: '兑换',
  redeemCodeTips: '兑换码区分大小写，请勿包含空格',
  redeemRecords: '兑换记录',
  carrot: '胡萝卜',
  redFlower: '小红花',
  noRedeemRecords: '暂无兑换记录',
  goGetRedeemCode: '快去获取兑换码兑换吧',
  obtained: '获得',
  pasteFailed: '粘贴失败',
  pleaseManuallyEnterRedeemCode: '请手动输入兑换码',
  redeemLimitReached: '多次输入无效兑换码，已临时限制兑换，10分钟后可重试',
  redeemCodeFormatError: '兑换码仅支持字母、数字和下划线，请重新输入',
  redeemSuccess: '对应权益成功发放至当前登录账号',
  redeemFailed: '兑换失败',
  // 注销账户
  deleteAccountSubtitle: '注销后所有数据将被永久删除，且无法恢复',
  deleteAccountRelatedMatters: '申请注销的关联事项：',
  deleteAccountPoint1: '1.账号处于安全状态',
  deleteAccountDesc1: '账号当前为正常使用状态，不存在被盗、违规、禁用等风险',
  deleteAccountPoint2: '2.账号资产已结清',
  deleteAccountDesc2: '账号下的虚拟资产资源放弃，包括但不限于已购买的作品、账户余额等',
  deleteAccountSecurityVerification: '注销安全验证',
  confirmDeleteAccount: '确认注销',
  confirmDeleteAccountMessage: '注销后所有数据将被永久删除，且无法恢复。确定要继续吗？',
  confirmDelete: '确定注销',
  processing: '处理中...',
  deleteAccountSuccess: '注销成功',
  deleteAccountFailed: '注销失败',
  deleteAccountFailedRetry: '注销失败，请稍后重试',
  updatedDate: '更新日期：',
  loadFailed: '加载失败',
  // 内容与我的喜欢
  noLikesYet: '暂无喜欢内容',
  goDiscoverLikes: '快去发现你喜欢的内容吧',
  thatsAllForNow: '暂时就是这些啦',
  today: '今天',
  yesterday: '昨天',
  earlier: '更早',
  author: '作者',
  shortStory: '短篇',
  novel: '小说',
  collection: '合集',
  posts: '动态',
  video: '视频',
  videoFeed: '视频动态',
  audioFeed: '音频动态',
  ongoing: '更新中',
  completed: '已完结',
  noCollectionsYet: '暂无收藏的合集',
  goDiscoverCollections: '快去发现精彩的合集吧',
  noFavoritedPostsYet: '暂无收藏的动态',
  goCollectPosts: '快去收藏喜欢的动态吧',
  collectionLimitReached: '已达到收藏上限',
  noBrowsingHistoryYet: '暂无浏览记录',
  goExploreContent: '快去探索精彩内容吧',
  purchased: '已购',
  subscribe: '订阅',
  package: '套餐',
  live: '直播',
  accompaniedDays: '已陪伴TA',
  days: '天',
  andAlso: '还有',
  daysRemainingToExpire: '天到期',
  view: '查看',
  expired: '已过期',
  hasExpired: '已到期',
  resubscribe: '再次订阅',
  noMore: '没有更多了',
  noSubscriptionHistoryYet: '还没有任何订阅记录哦～',
  noPurchaseHistoryYet: '还没有任何购买记录哦～',
  noLiveHistoryYet: '还没有任何直播记录哦～',
  noPurchasedCollectionsYet: '还没有任何购买的合集哦～',
  copies: '份',
  upcoming: '待开播',
  living: '直播中',
  canEnterLiveRoom: '可进入直播间',
  liveInterruptedWaiting: '直播暂时中断，等待恢复',
  liveEnded: '直播已结束',
  ticketPurchased: '已购本场直播门票',
  support: '支持',
  pleaseSelectSubscriptionPackage: '请选择订阅套餐',
  purchasing: '购买中...',
  purchaseSuccess: '购买成功',
  purchaseFailed: '购买失败',
  user: '用户',
  // 我的钱包与充值
  transactionRecord: '交易记录',
  purchaseQuantity: '购买数量',
  quantity: '数量',
  paymentMethod: '支付方式',
  otherPaymentMethods: '其他支付方式',
  clickToSwitch: '点击切换',
  rechargeProblemQuestion: '充值遇到问题？',
  userRechargeAgreementWithBracket: '《用户充值协议》',
  recharge: '充值',
  rechargeSuccess: '充值成功',
  thisRecharge: '本次充值',
  creditedToAccount: '，到账',
  carrots: '胡萝卜',
  problemQuestion: '遇到问题？',
  largeRechargeAmountLabel: '您本次充值金额为',
  confirmAmountCorrect: '请确认金额是否正确',
  noRefundAfterRecharge: '充值完成后将无法退款',
  confirm: '确认',
  scanAlipayQrTip: '请使用手机支付宝扫描二维码支付',
  clickQrToLaunchAlipayTip: '手机可点击二维码唤起支付宝支付',
  clickToRefresh: '点击刷新',
  qrCodeExpired: '二维码已失效',
  paymentNotDetectedTip: '暂未检测到支付，请完成支付后再刷新',
  back: '返回',
  paymentCompletedRefresh: '支付完成 刷新页面',
  confirmingPaymentResult: '支付结果确认中',
  paymentNotSuccessfulRetryOrContact: '支付未成功，请重试或联系客服',
  paymentCancelled: '支付取消',
  paymentQueryTimeout: '支付结果查询超时，请查看交易记录',
  notLoggedIn: '未登录',
  copySuccess: '复制成功',
  max99: '最大99',
  orderClosed: '订单已关闭',
  pleaseAgreeRechargeAgreement: '请先勾选用户充值协议',
  pleaseSelectQuantity: '请选择数量',
  pleaseEnterQuantity: '请输入数量',
  pleaseSelectPaymentMethod: '请选择支付方式',
  paymentMethodNotSupported: '当前支付方式暂不支持充值',
  recharging: '充值中...',
  pleaseCheckPaymentInfo: '请检查支付信息',
  cardFormLoadFailed: '银行卡表单未加载，请检查网络后重试',
  rechargeFailed: '充值失败',
  rechargeFailedRetry: '充值失败，请稍后重试',
  paymentFailedRetry: '支付失败，请稍后重试',
  paymentCancelledByUser: '已取消支付',
  pleaseCompleteRechargeAndInfo: '请先完成充值并填写支付信息',
  paymentCredentialMissing: '支付凭证缺失，请重新点击充值',
  paymentFailed: '支付失败',
  pleaseCompletePaymentOperation: '请完成支付操作',
  paymentProcessing: '支付处理中',
  contentNotExist: '内容不存在',
  alipay: '支付宝',
  wechatPay: '微信支付',
  officialRechargeStore: '官方充值店铺',
  recent180DaysTip: '仅展示最近180天记录',
  noTransactionRecordYet: '暂无交易记录',
  rechargeOrConsumeTip: '快去充值或消费吧',
  loadMore: '继续加载',
  platformGift: '平台赠送',
  liveIncome: '直播收入',
  transaction: '交易',
  getTransactionRecordFailed: '获取交易记录失败',
  loadFailedRetry: '加载失败，请重试',
  // 首页 Feed 与 Cookie
  recommendChrome: '推荐使用Chrome浏览器访问',
  happeningNow: '正在发生',
  creatorsFreshIdeas: '创作者们新鲜出炉的想法与作品',
  viewFullText: '查看全文',
  unlockNow: '立即解锁',
  follow: '关注',
  all: '全部',
  weUseCookies: '我们使用Cookie',
  cookieConsentDesc: '本网站使用 Cookie 来提升您的使用体验、分析网站使用情况，并为您提供个性化广告。点击“全部接受”即表示您同意使用所有 Cookie。您也可以点击“全部拒绝”或自定义您的偏好设置。',
  acceptAll: '全部接受',
  reject: '拒绝',
  swipeUpToLoadMore: '上滑加载更多',
  shareLinkCopied: '已复制分享链接',
  copyFailed: '复制失败',
  subscriberOnlyContent: '本内容仅对订阅者开放',
  unlockToViewFullContent: '解锁查看完整内容',
  subscribeToUnlockPrefix: '订阅',
  subscribeToUnlockSuffix: '即可解锁',
  minCarrotsToUnlockPrefix: '最低',
  minCarrotsToUnlockSuffix: '胡萝卜 可解锁内容',
  purchaseCollectionToUnlock: '购买合集即可解锁',
  cannotPlay: '无法播放',
  contentIncomplete: '内容信息不完整',
  followed: '已关注',
  followFailed: '关注失败',
  operationFailed: '操作失败',
  creator: '创作者',
  roomIdNotExist: '房间ID不存在',
  liveStatusAbnormal: '直播状态异常',
  getLiveRoomInfoFailed: '获取直播间信息失败',
  networkErrorRetry: '网络异常，请稍后重试',
  liveReminderSet: '已设置开播提醒',
  followSuccess: '关注成功',
  feedChannel: '动态频道',
  // 活动专题
  popularityRanking: '人气榜',
  cpRanking: 'CP榜',
  sendFlowers: '去送花',
  rankingDataNotExist: '榜单数据不存在',
  topContribution: '贡献TOP',
  rushToGrab: '速来抢占',
  notConfigured: '暂未配置',
  getArticleFailed: '获取文章失败',
  activityTopic: '活动专题',
  tenThousand: '万',
  hundredMillion: '亿',
  // 个人中心 profile
  myProfile: '个人主页',
  confirmDeletePost: '确认删除',
  deletePostConfirmMessage: '确定要删除这条内容吗？删除后将无法恢复。',
  likes: '喜欢',
  collections: '收藏',
  history: '足迹',
  creationCenter: '创作中心',
  contactCustomerService: '联系客服',
  edit: '编辑',
  noRelatedContentFound: '没有找到相关内容',
  delete: '删除',
  creation: '创作',
  wallet: '钱包',
  customerService: '客服',
  startBroadcast: '开播',
  copyEmailSuccess: '复制邮箱成功',
  openInBrowserTip: '请在电脑浏览器上打开，以获得最佳体验',
  addressCopiedTip: '地址已复制\n请在电脑浏览器上打开\n以获得最佳体验',
  addressCopied: '地址已复制',
  pleaseOpenInDesktopBrowser: '请在电脑浏览器上打开',
  forBestExperience: '以获得最佳体验',
  articleInfoIncomplete: '文章信息不完整',
  collectionInfoIncomplete: '合集信息不完整',
  pleaseLoginFirst: '请先登录',
  operationFailedRetry: '操作失败，请稍后重试',
  postIdNotExist: '动态ID不存在',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  justNow: '刚刚',
  minutesAgo: '分钟前',
  daysAgo: '天前',
  tomorrow: '明天',
  daysLater: '天后',
  // 合集导航 CollectionNavigation
  catalog: '目录',
  nextChapter: '下一章',
  previousChapter: '上一章',
  // 数量选择器 PcmQuantitySelector
  quickSelect: '一键速选',
  customQuantity: '自定义数量',
  // 视频详情页 video-detail
  videoUnavailableOrDeleted: '视频不存在或已下架',
  backToHomeForMore: '返回首页看看其他精彩内容吧',
  expand: '展开',
  collapse: '收起',
  lastEditedAt: '最后一次编辑于',
  actors: '出镜',
  creationTeam: '创作团队',
  comments: '评论',
  reply: '回复',
  replyToPrefix: "回复 {'@'}",
  expandMoreReplies: '展开更多回复',
  collapseReplies: '收起回复',
  leaveYourThoughts: '留下你的感受',
  send: '发送',
  favorited: '已收藏',
  favoriteCollection: '收藏合集',
  nothingHere: '这里什么都没有呢',
  collapseCatalog: '收起目录',
  goodsIdCannotBeEmpty: '商品ID不能为空',
  packageIdCannotBeEmpty: '套餐ID不能为空',
  collectionIdCannotBeEmpty: '合集ID不能为空',
  purchaseFailedRetry: '购买失败，请稍后重试',
  purchaseFailedRetryShort: '购买失败，请重试',
  nextEpisodeRequiresUnlock: '下一集需要解锁',
  alreadyLastEpisode: '已经是最后一集了',
  autoPlayFailed: '自动播放失败',
  copyLinkSuccess: '复制链接成功',
  article: '文章',
  picture: '图片',
  wordsCountUnit: '字',
  commentSendSuccess: '评论发送成功',
  // 他人主页 user-profile
  acknowledgements: '致谢',
  alreadyHave: '已有 ',
  peopleSupported: '人支持',
  subscribeToUser: '订阅TA',
  subscribed: '已订阅',
  duringValidityPeriod: '有效期内',
  fansCircleContentUnlock: '粉丝圈内容限时解锁',
  slashUser: 'Slash用户',
  userInfoIncomplete: '用户信息不完整',
  cannotFollowSelf: '不能关注自己',
  unfollowed: '已取消关注',
  dayUnit: '天',
  enter: '进入',
  // 简剧/短篇 short-story
  noCreationTeam: '暂无创作团队',
  goToNextStory: '进入下一篇',
  noDeletePermission: '无删除权限',
  previewImageFailed: '预览图片失败',
  authorInfoIncomplete: '作者信息不完整',
  pleaseEnterComment: '请输入评论内容',
  commentIdCannotBeEmpty: '评论ID不能为空',
  postCommentFailed: '发表评论失败',
  unfavorited: '已取消收藏',
  liked: '已点赞',
  unliked: '已取消点赞',
  commentInfoIncomplete: '评论信息不完整',
  replyInfoIncomplete: '回复信息不完整',
  unfollowFailed: '取消关注失败',
  alreadyLastStory: '已经是最后一篇了',
  nextStoryNotFound: '未找到下一篇文章',
  noMoreStories: '暂无更多文章',
  // 小说详情 novel-detail
  alreadyLastChapter: '已经是最后一章了',
  nextChapterRequiresUnlock: '下一章需要解锁',
  jumpFailed: '跳转失败',
  alreadyFirstChapter: '已经是第一章了',
  favoriteSuccess: '收藏成功',
  unfavoriteSuccess: '取消收藏成功',
  collectionAlreadyFavorited: '该合集已收藏',
  collectionNotFavorited: '该合集未收藏',
  collectionIdNotExist: '合集ID不存在',
  getCollectionDetailFailed: '获取合集详情失败',
  getChapterListFailed: '获取章节列表失败',
  noChaptersInCollection: '该合集暂无章节',
  // 搜索结果 search-result
  searchPlaceholder: '搜你想看的内容',
  comprehensive: '综合',
  noRelatedContent: '未找到相关内容',
  tryOtherKeywords: '试试其他关键词吧',
  pleaseEnterSearchContent: '请输入搜索内容',
  searchFailedRetry: '搜索失败，请稍后重试',
  searchUserFailedRetry: '搜索用户失败，请稍后重试',
  confirmDeleteSearchHistory: '确定要删除搜索记录吗？',
  cleared: '已清空',
  // 重置密码 reset-password
  currentAccountLabel: '当前账号：',
  pleaseGetCodeFirst: '请先获取验证码',
  verificationExpired: '验证信息已过期，请重新获取验证码',
  passwordChangeSuccess: '密码修改成功',
  modifying: '修改中...',
  passwordChangeFailedRetryLong: '密码修改失败，请稍后重试',
  // 首页 index
  viewAll: '...查看全部',
  reachedTheEnd: '到底啦',
  likeToWatch: '喜欢看',
  swipeUpToPlay: '向上滑播放',
  swipeUpIconText: '👆 向上滑',
  swipeLeftRight: '左右划',
  switchContent: '切换内容',
  swipeIconText: '👈 滑动 👉',
  ageVerification: '年龄验证',
  areYou18YearsOld: '请问您是否年满18周岁',
  adultContentWarning: 'Slash99.com包含成人内容，请您确认自己是否已满18岁。未满18岁访问本网站将受到所在国家或地区法律法规的限制。',
  leave: '离开',
  yesIm18: '是的，我已满18周岁',
  loginOrRegister: '登录 / 注册',
  editorChoice: '编辑精选',
  livePreview: '直播预告',
  enterLiveRoom: '进入直播间',
  refreshBatch: '换一换',
  stayTuned: '敬请期待',
  loggedOut: '已退出登录',
  liveRoomInfoIncomplete: '直播间信息不完整',
  loadUserInfoFailed: '加载用户信息失败',
  postInfoIncomplete: '动态信息不完整',
  videoLoadFailed: '视频加载失败',
  dataAnomaly: '数据异常',
  // 分类与组件 category / components
  noRelatedContentCategory: '暂无相关内容',
  tryAnotherCategory: '换个分类看看吧',
  filterTags: '筛选标签',
  containsAnyOneTag: '包含任意1个标签',
  clear: '清空',
  confirmSelect: '确定',
  modifyFilter: '修改筛选',
  maxThreeTags: '最多只能选择3个标签',
  acknowledgementsList: '致谢列表',
  noSupportersYet: '暂无支持者',
  alreadyHaveShort: '已有',
  // 评论与支付 comments / alipay
  paymentSuccess: '支付成功',
  envNotSupportAutoAlipay: '当前环境不支持自动拉起支付宝',
  repliesCountSuffix: '条回复',
  share: '分享',
  viewAllReplies: '查看全部回复',
  footerList: {
    about: '关于',
    userAgreement: '用户协议',
    privacyPolicy: '隐私政策',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    feedback: '问题反馈',
    submission: '投稿',
    otherMatters: '其他事项',
    returnPolicy: '退换货政策',
    intellectualProperty: '知识产权',
    help: '帮助',
    '关于': '关于',
    '用户协议': '用户协议',
    '隐私政策': '隐私政策',
    '关于我们': '关于我们',
    '联系我们': '联系我们',
    '问题反馈': '问题反馈',
    '投稿': '投稿',
    '其他事项': '其他事项',
    '退换货政策': '退换货政策',
    '知识产权': '知识产权',
    '帮助': '帮助',
  },
  userDrawer: { // 抽屉导航
    language: [
      { name: '简体中文' },
      { name: '繁体中文' },
      { name: '英文' },
      { name: '俄语' },
      { name: '法文' },
      { name: '泰语' },
      { name: '老挝语' },
    ],
    contest: '营销大赛',
  },
  tabbar: {
    data: {
      'tab1': '首页',
    },
  },
  page: {
    contest: {
      applyFailed: '报名失败'
    },
  }
,
  poorNetworkSwitchQuality: '当前网络环境较差，建议切换清晰度',
  loadFailedPleaseRefresh: '加载失败，请刷新页面重试',
  refresh: '刷新',
  definition: '清晰度',
  autoQuality: '自动',
  playbackSpeed: '倍速',
  subtitle: '字幕',
  translate: '翻译',
  becomeSupporter: '成为支持者',
  fansCircleBenefits: '粉丝圈权益',
  inventoryColon: '库存：',
  month: '月',
  insufficientBalanceGoRecharge: '余额不足，去充值',
  noPurchasableOptions: '暂无可购买选项',
  fansBadge: '粉丝标识',
  officialEventsPriority: '官方活动优先参加',
  purchaseBonus: '购买加赠',
  home: '主页',
  my: '我的',
  listing: '上架中',
  supportCreator: '支持创作者',
  goodsListing: '商品上架中',
  toUnlockContent: '即可解锁内容',
  purchaseCollection: '购买合集',
  quarter: '季',
  year: '年',
  total: '合计',
  notContainCurrentContent: '不含当前内容',
  price: '价格',
  buy: '购买',
  noPurchasablePackages: '暂无可购买套餐',
  selectGifting: '选择送礼',
  pleaseSelectTwoPersons: '请选择两个人',
  sendToColon: '送给：',
  singlePerson: '单人',
  cp: 'CP',
  selectTwoPersons: '选择两个人',
  insufficientInventoryGoGet: '库存不足，去获得',
  sendOut: '送出',
  pleaseSelectRecipient: '请选择送礼对象',
  sendingOut: '送出中...',
  sendFlowerSuccess: '送花成功',
  sendFlowerFailedRetry: '送花失败，请重试',
  paramsError: '参数错误',
  contentDetail: '内容详情',
  lightMode: '浅色模式',
  // 直播间多语言 (Live stream i18n)
  onlineUsers: "在线用户",
  currentContributionRank: "本场贡献榜",
  noOnlineUsers: "暂无在线用户",
  noContributionRecord: "本场暂无贡献记录",
  contributionTipDesc: "点赞、发弹幕、分享或送礼，都可以增加本场贡献值。",
  giveGift: "送礼",
  sendGift: "送礼物",
  liveInterruptedTemp: "直播暂时中断",
  streamerRecoveringTip: "主播正在尝试恢复，请稍后再试",
  purchasedBenefitsRetained: "已购权益保留，无需重复购买",
  liveInterruptedCannotBuy: "直播暂时中断，当前暂不可购买",
  liveStreamAbnormal: "本场直播异常",
  backToHome: "返回首页",
  liveStreamEnded: "本场直播已结束",
  liveRoomLoading: "直播间加载中...",
  retry: "重试",
  startedBroadcast: "已开播",
  livingNow: "正在直播",
  chat: "聊天",
  buyAfterLiveResume: "直播恢复后可购买",
  chatAfterLiveResume: "直播恢复后可继续互动",
  canChatAfterPurchase: "购买后可发送弹幕",
  canChatAfterPurchaseNotice: "购买后即可发送弹幕",
  supportWithDanmaku: "弹幕支持下～",
  exitClearScreen: "退出清屏",
  clearScreen: "清屏",
  feedbackProblem: "反馈问题",
  clickToPlay: "点击播放",
  feedbackProblemTitle: "问题反馈",
  describeFeedback: "描述反馈",
  describeProblemPlaceholder: "请描述你遇到的问题...",
  uploadScreenshot: "上传截图",
  optional: "选填",
  add: "添加",
  submitFeedback: "提交反馈",
  give: "赠送",
  liveNotStarted: "直播尚未开始",
  liveAbnormal: "直播异常",
  liveInterrupted: "直播已中断",
  playbackFailedRetry: "播放失败，请手动重试",
  switchingQuality: "切换清晰度中...",
  contributionDescTitle: "贡献值说明",
  contributionDetailDesc: "贡献值用于衡量你在本场直播中的支持与互动情况。观看直播、参与互动、赠送礼物、分享直播等行为，都可能提升你的贡献值。不同互动行为对贡献值的影响有所不同，具体以实际展示为准。",
  totalPeopleCount: "共 {count} 人",
  userDefault: "用户",
  me: "我",
  gapToBeSurpassed: "距被超越还差{gap}贡献值",
  gapToSurpassPrevious: "距超越上一名还差{gap}贡献值",
  gapToGetRanked: "距有排名还差{gap}贡献值",
  loginToWatchAndInteract: "登录后观看直播并参与互动",
  loginSlashRegister: "登录 / 注册",
  startBroadcastAt: "{time} 开播",
  hasAccessDirectWatch: "已获得权益·开播后可直接观看",
  unlockToWatchLiveAndChat: "解锁后可观看直播画面与弹幕互动",
  saleStartBroadcastAt: "售卖 · {time} 开播",
  buyThisLiveStream: "{price} 购买本场",
  fullscreen: "全屏",
  senderSentGiftCombo: "{sender} 送出 {gift} ×{count}",
  comboCountText: "{count}连击!",
  combo: "连击",
  insufficientBalance: "余额不足",
  giftBalanceModalMsg: "本次赠送需{cost}，当前余额{balance}。",
  goRecharge: "去充值",
  loginToInteractNotice: "观看直播、发弹幕、送礼物、看贡献榜需先登录",
  loginToViewChat: "登录后查看弹幕、参与互动",
  platformNotice: "平台提示",
  hostAnnouncement: "主播公告",
  streamerNotStartedChatNotice: "主播还未开播，开播后弹幕将在此展示",
  sendFailedRetry: "发送失败，请重试",
  loginToChatPlaceholder: "登录后参与聊天",
  notStartedCannotSend: "暂未开播，暂不可发送",
  messagesFailedClickRetry: "{count} 条消息发送失败，点击重发",
  favoriteProgramList: "收藏节目单",
  stillNeed: "还差",
  sentDot: "赠送 · ",
  sent: "送出",
  sessionNotExist: "场次信息不存在",
  insufficientCarrotRechargeConfirm: "胡萝卜余额不足，是否前往充值？",
  danmakuMax50Words: "弹幕最多 50 字",
  mutedByHostCannotChat: "你已被主播禁言，暂时无法发送弹幕",
  chatServiceConnecting: "聊天服务连接中，请稍后重试",
  networkDisconnectedCheck: "网络已断开，请检查网络连接",
  connectionDisconnectedReconnecting: "连接已断开，正在尝试重连...",
  kickedOutReconnecting: "被踢出，正在重连...",
  insufficientCarrotsComboStopped: "胡萝卜不足，连击已停止",
  sendGiftSuccessCelebration: "🎉 赠送成功",
  giftOffShelfComboStopped: "礼物已下架，连击已停止",
  giftOffShelf: "礼物已下架",
  liveInterruptedCannotGift: "直播信号中断，暂时无法送礼",
  notStartedCannotGift: "暂未开播，暂不可送礼",
  giftSendSuccess: "礼物发送成功",
  likeFailed: "点赞失败",
  linkCopied: "链接已复制",
  copyFailedRetry: "复制失败，请重试",
  shareFailedRetry: "分享失败，请重试",
  screenCleared: "已清屏",
  screenRestored: "已恢复",
  linkCopiedOpenBrowser: "链接已复制，请在浏览器中打开",
  screenshotAdded: "截图已添加",
  feedbackSubmitSuccess: "反馈提交成功",
  liveStreamCannotWatchRefresh: "直播暂时无法观看，请稍后刷新试试",
  favoritedCollection: "已收藏合集",
  unfavoritedCollection: "已取消收藏",
  userEnteredLiveRoom: "进入了直播间",
  userFollowedHost: "关注了主播",
  userLikedHost: "给主播点了喜欢 ❤️",
  anonymous: "匿名",
  orientationCacheCleared: "已清除方向缓存，刷新后重新检测",
  todayWithTime: "今天 {time}",
  tomorrowWithTime: "明天 {time}",
  dayAfterTomorrowWithTime: "后天 {time}",
  monthDayTime: "{month}月{day}日 {time}",
  postedLivePreview: "发布了直播预告",
  watchingCount: "{count}在看",
  defaultLivingTitle: "今晚陪你聊聊那些故事",
  defaultPreviewTitle: "明日预告：千古世界探秘",
  postCountUnit: "{count}个动态",
  wordsCount: "{count}字",
  tenThousandWordsCount: "{count}万字",
  qualityUltra: "超清",
  qualityHigh: "高清",
  qualityStandard: "标清",
  qualitySmooth: "流畅",
  subtitleBilingual: "🌐 中文 + English",
  subtitleEnglishOnly: "English",
  subtitleOff: "关闭",
  "在线用户": "在线用户",
  "本场贡献榜": "本场贡献榜",
  "暂无在线用户": "暂无在线用户",
  "本场暂无贡献记录": "本场暂无贡献记录",
  "点赞、发弹幕、分享或送礼，都可以增加本场贡献值。": "点赞、发弹幕、分享或送礼，都可以增加本场贡献值。",
  "送礼": "送礼",
  "送礼物": "送礼物",
  "直播暂时中断": "直播暂时中断",
  "主播正在尝试恢复，请稍后再试": "主播正在尝试恢复，请稍后再试",
  "已购权益保留，无需重复购买": "已购权益保留，无需重复购买",
  "直播暂时中断，当前暂不可购买": "直播暂时中断，当前暂不可购买",
  "本场直播异常": "本场直播异常",
  "返回首页": "返回首页",
  "本场直播已结束": "本场直播已结束",
  "直播间加载中...": "直播间加载中...",
  "重试": "重试",
  "直播中": "直播中",
  "已开播": "已开播",
  "已关注": "已关注",
  "关注": "关注",
  "正在直播": "正在直播",
  "进入": "进入",
  "全部": "全部",
  "聊天": "聊天",
  "直播恢复后可购买": "直播恢复后可购买",
  "直播恢复后可继续互动": "直播恢复后可继续互动",
  "购买后可发送弹幕": "购买后可发送弹幕",
  "购买后即可发送弹幕": "购买后即可发送弹幕",
  "弹幕支持下～": "弹幕支持下～",
  "发送": "发送",
  "清晰度": "清晰度",
  "退出清屏": "退出清屏",
  "清屏": "清屏",
  "反馈问题": "反馈问题",
  "点击播放": "点击播放",
  "描述反馈": "描述反馈",
  "请描述你遇到的问题...": "请描述你遇到的问题...",
  "上传截图": "上传截图",
  "选填": "选填",
  "添加": "添加",
  "提交中...": "提交中...",
  "提交反馈": "提交反馈",
  "充值": "充值",
  "赠送": "赠送",
  "房间ID不存在": "房间ID不存在",
  "加载失败": "加载失败",
  "直播尚未开始": "直播尚未开始",
  "直播异常": "直播异常",
  "直播已中断": "直播已中断",
  "播放失败，请手动重试": "播放失败，请手动重试",
  "切换清晰度中...": "切换清晰度中...",
  "贡献值说明": "贡献值说明",
  "贡献值用于衡量你在本场直播中的支持与互动情况。观看直播、参与互动、赠送礼物、分享直播等行为，都可能提升你的贡献值。不同互动行为对贡献值的影响有所不同，具体以实际展示为准。": "贡献值用于衡量你在本场直播中的支持与互动情况。观看直播、参与互动、赠送礼物、分享直播等行为，都可能提升你的贡献值。不同互动行为对贡献值的影响有所不同，具体以实际展示为准。",
  "共 {count} 人": "共 {count} 人",
  "用户": "用户",
  "我": "我",
  "距被超越还差{gap}贡献值": "距被超越还差{gap}贡献值",
  "距超越上一名还差{gap}贡献值": "距超越上一名还差{gap}贡献值",
  "距有排名还差{gap}贡献值": "距有排名还差{gap}贡献值",
  "登录后观看直播并参与互动": "登录后观看直播并参与互动",
  "登录 / 注册": "登录 / 注册",
  "直播预告": "直播预告",
  "{time} 开播": "{time} 开播",
  "已获得权益·开播后可直接观看": "已获得权益·开播后可直接观看",
  "解锁后可观看直播画面与弹幕互动": "解锁后可观看直播画面与弹幕互动",
  "售卖 · {time} 开播": "售卖 · {time} 开播",
  "{price} 购买本场": "{price} 购买本场",
  "全屏": "全屏",
  "{sender} 送出 {gift} ×{count}": "{sender} 送出 {gift} ×{count}",
  "{count}连击!": "{count}连击!",
  "连击": "连击",
  "余额不足": "余额不足",
  "余额不足，去充值": "余额不足，去充值",
  "本次赠送需{cost}，当前余额{balance}。": "本次赠送需{cost}，当前余额{balance}。",
  "去充值": "去充值",
  "观看直播、发弹幕、送礼物、看贡献榜需先登录": "观看直播、发弹幕、送礼物、看贡献榜需先登录",
  "登录后查看弹幕、参与互动": "登录后查看弹幕、参与互动",
  "平台提示": "平台提示",
  "主播公告": "主播公告",
  "主播还未开播，开播后弹幕将在此展示": "主播还未开播，开播后弹幕将在此展示",
  "发送失败，请重试": "发送失败，请重试",
  "登录后参与聊天": "登录后参与聊天",
  "暂未开播，暂不可发送": "暂未开播，暂不可发送",
  "{count} 条消息发送失败，点击重发": "{count} 条消息发送失败，点击重发",
  "已收藏": "已收藏",
  "收藏节目单": "收藏节目单",
  "这里什么都没有呢": "这里什么都没有呢",
  "收起目录": "收起目录",
  "还差": "还差",
  "赠送 · ": "赠送 · ",
  "送出": "送出",
  "场次信息不存在": "场次信息不存在",
  "胡萝卜余额不足，是否前往充值？": "胡萝卜余额不足，是否前往充值？",
  "弹幕最多 50 字": "弹幕最多 50 字",
  "你已被主播禁言，暂时无法发送弹幕": "你已被主播禁言，暂时无法发送弹幕",
  "聊天服务连接中，请稍后重试": "聊天服务连接中，请稍后重试",
  "网络已断开，请检查网络连接": "网络已断开，请检查网络连接",
  "连接已断开，正在尝试重连...": "连接已断开，正在尝试重连...",
  "被踢出，正在重连...": "被踢出，正在重连...",
  "胡萝卜不足，连击已停止": "胡萝卜不足，连击已停止",
  "🎉 赠送成功": "🎉 赠送成功",
  "礼物已下架，连击已停止": "礼物已下架，连击已停止",
  "礼物已下架": "礼物已下架",
  "直播信号中断，暂时无法送礼": "直播信号中断，暂时无法送礼",
  "暂未开播，暂不可送礼": "暂未开播，暂不可送礼",
  "礼物发送成功": "礼物发送成功",
  "点赞失败": "点赞失败",
  "链接已复制": "链接已复制",
  "复制失败，请重试": "复制失败，请重试",
  "分享失败，请重试": "分享失败，请重试",
  "已清屏": "已清屏",
  "已恢复": "已恢复",
  "链接已复制，请在浏览器中打开": "链接已复制，请在浏览器中打开",
  "截图已添加": "截图已添加",
  "反馈提交成功": "反馈提交成功",
  "直播暂时无法观看，请稍后刷新试试": "直播暂时无法观看，请稍后刷新试试",
  "已收藏合集": "已收藏合集",
  "已取消收藏": "已取消收藏",
  "进入了直播间": "进入了直播间",
  "关注了主播": "关注了主播",
  "给主播点了喜欢 ❤️": "给主播点了喜欢 ❤️",
  "匿名": "匿名",
  "已清除方向缓存，刷新后重新检测": "已清除方向缓存，刷新后重新检测",
  "今天 {time}": "今天 {time}",
  "明天 {time}": "明天 {time}",
  "超清": "超清",
  "高清": "高清",
  "标清": "标清",
  "流畅": "流畅",
  sale: "售卖",
  "售卖": "售卖",
  buyThisTicket: "购买本场",
  "购买本场": "购买本场",
  costForGiftColon: "本次赠送需",
  "本次赠送需": "本次赠送需",
  currentBalanceColon: "，当前余额",
  "，当前余额": "，当前余额",
  period: "。",
  "。": "。",
  submitFailed: "提交失败",
  selectedChapterColon: "已选择：",
  "已选择：": "已选择：",
  kickedOut: "被踢出",
  "被踢出": "被踢出",
  connectionDisconnected: "连接断开",
  "连接断开": "连接断开",
  reconnectingNotice: "{reason}，正在重连...",
  "{reason}，正在重连...": "{reason}，正在重连...",
  gift: "礼物",
  "礼物": "礼物",
  "视频": "视频",
  varietyShow: "综艺",
  "综艺": "综艺",
  playback: "回放",
  "回放": "回放",
  ended: "已结束",
  "已结束": "已结束",
  originalQuality: "原画",
  "原画": "原画",
  "自动": "自动",
  blurayQuality: "蓝光",
  "蓝光": "蓝光",
  standardPlusQuality: "标强",
  "标强": "标强",
  hot: "热门",
  "热门": "热门",
  cheap: "便宜",
  "便宜": "便宜",
  premium: "高级",
  "高级": "高级",
  "发布了直播预告": "发布了直播预告",
  "今晚陪你聊聊那些故事": "今晚陪你聊聊那些故事",
  "明日预告：千古世界探秘": "明日预告：千古世界探秘",
  "账号不能为空": "账号不能为空",
  "1小时内最多发送{count}次验证码，请{minutes}分钟后再试": "1小时内最多发送{count}次验证码，请{minutes}分钟后再试",
  hottest: "最热",
  latest: "最新",
  "最热": "最热",
  "最新": "最新",
  newest: "最新",
  pureLove: "纯爱",
  lily: "百合",
  ceo: "霸道总裁",
  lady: "大小姐",
  detective: "侦探",
  "月": "月",
  "季": "季",
  "年": "年",
  "天": "天"
};
